import _styled from "styled-components";
var _RemoveScroll;
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Popper } from "@crehana/ui";
import cn from "classnames";
import { RemoveScroll } from "react-remove-scroll";
import { useMainMenuContext } from "../../../hooks";
import UserMenuContent from "../components/UserMenuContent";
import { jsx as _jsx } from "react/jsx-runtime";
var UserMenuDesktopPopper = function UserMenuDesktopPopper(_ref) {
  var userMenuAvatarRef = _ref.userMenuAvatarRef,
    isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss;
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme,
    themeName = _useMainMenuContext.themeName,
    variant = _useMainMenuContext.variant;
  return /*#__PURE__*/_jsx(_StyledPopper, {
    anchorRef: userMenuAvatarRef,
    isVisible: isOpen,
    onDismiss: onDismiss,
    dismissOnClickOutside: true,
    isDark: themeName.submenu === 'dark',
    className: cn('flex flex-col', theme.submenu.backgroundColorClassName, theme.submenu.textColorClassName),
    arrowProps: {
      visible: true,
      triggerPosition: 'center',
      className: theme.submenu.popperIndicatorColorClassName,
      css: variant === 'sidebar' ? "\n              /* Temporal hack to place the arrow to the right */\n              transform: translateX(calc(328px));\n            " : "\n              /* Temporal hack  to place the arrow to the right on full hd screens */\n              @media (max-width: 2052px) {\n                transform: translateX(calc(328px));\n              }\n            "
    },
    position: "bottom",
    $_css: theme.submenu.userMenuPopperWidth,
    $_css2: variant !== 'sidebar' ? "\n            /* Temporal hack for full hd screens */\n            @media (min-width: 2052px) {\n              transform: translateX(calc(-100% + 32px));\n            }\n          " : '',
    children: _RemoveScroll || (_RemoveScroll = /*#__PURE__*/_jsx(RemoveScroll, {
      children: /*#__PURE__*/_jsx(UserMenuContent, {
        isDesktop: true
      })
    }))
  });
};
export default UserMenuDesktopPopper;
var _StyledPopper = /*#__PURE__*/_styled(Popper).withConfig({
  componentId: "sc-faj618-0"
})(["\n        width: ", "px;\n        ", "\n      "], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});